import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  allSelected,
  fetchPosts,
  mostLikedSelected,
  newestSelected,
  SavedSelected,
} from "../../features/posts/postsSlice";

const Sidebar = () => {
  // const [radio, setRadio] = useState(false);

  const dispatch = useDispatch();

  const handleFilter = (e) => {
    // setRadio(!radio);
    if (e.target.id === "lws-all") {
      dispatch(allSelected());
    } else if (e.target.id === "lws-saved") {
      dispatch(SavedSelected());
    }
  };

  const handleSort = (e) => {
    console.log(e.target.value);
    if (e.target.value === "") {
      dispatch(allSelected());
    } else if (e.target.value === "newest") {
      dispatch(newestSelected());
    } else if (e.target.value === "most_liked") {
      dispatch(mostLikedSelected());
    }
  };

  return (
    <aside>
      <div className="sidebar-items">
        <div className="sidebar-content">
          <h4>Sort</h4>
          <select
            name="sort"
            id="lws-sort"
            className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
            onClick={handleSort}
          >
            <option value="">Default</option>
            <option value="newest">Newest</option>
            <option value="most_liked">Most Liked</option>
          </select>
        </div>
        <div className="sidebar-content">
          <h4>Filter</h4>
          <div className="radio-group">
            {/* <!-- handle filter on button click --> */}
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-all"
                // checked={radio}
                className="radio"
                onChange={handleFilter}
              />
              <label htmlFor="lws-all">All</label>
            </div>
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-saved"
                className="radio"
                // checked={radio}
                onChange={handleFilter}
              />
              <label htmlFor="lws-saved">Saved</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
